import React from "react";
import { Title } from "../../../../../../Common/Typography";
import { Label } from "../../../../../../Inputs";
import { Radio, Text } from "../../../../../../Inputs/react-hook-form";
import {
  getUiSchemaPropertyFormPath,
  useBuilderFormContext,
} from "../../form/form";
import {
  FormSection,
  FormSectionTitleWrapper,
} from "../__styles__/SidebarColumn";
import { WidgetSettingsContainer } from "./__styles__/WidgetSettings";
import type { InputSettingsFormProps } from "./FieldSettingsView";
import { DisplaySettings } from "./shared/DisplaySettings";
import {
  CreatorPermissionsConfig,
  ViewerPermissionsConfig,
} from "./shared/FieldPermissionsConfig";
import { FieldSettingsConfig } from "./shared/FieldSettingsConfig";
import { HelperTextInput } from "./shared/HelperTextInput";
import { PlaceholderTextInput } from "./shared/PlaceholderTextInput";

export function UniqueIdFieldSettings({
  fieldPath,
  isReadOnly,
  isModuleInput,
}: InputSettingsFormProps) {
  const { register, control } = useBuilderFormContext();

  const uniqueIdPrefixPropertyFormPath = getUiSchemaPropertyFormPath(
    fieldPath,
    "prefix",
  );
  const numberTypePropertyFormPath = getUiSchemaPropertyFormPath(
    fieldPath,
    "numberType",
  );

  return (
    <WidgetSettingsContainer>
      <FieldSettingsConfig
        fieldPath={fieldPath}
        isModuleInput={isModuleInput}
        isReadOnly={isReadOnly}
        isRequiredFieldDisabled={true}
      />
      <HelperTextInput fieldPath={fieldPath} isReadOnly={isReadOnly} />
      <PlaceholderTextInput fieldPath={fieldPath} isReadOnly={true} />
      <Text
        label="Unique id prefix"
        description="Optional text to add a prefix before the ID like PDA- or {{year}}"
        disabled={isReadOnly}
        data-testid="unique-id-prefix-input"
        {...register(uniqueIdPrefixPropertyFormPath)}
      />
      <div>
        <Label text="Number type" htmlFor={numberTypePropertyFormPath} />
        <Radio
          control={control}
          name={numberTypePropertyFormPath}
          disabled={isReadOnly}
          options={[
            { value: "ascending", text: "Ascending order" },
            { value: "random", text: "Randomized" },
          ]}
        />
      </div>
      <FormSection>
        <FormSectionTitleWrapper>
          <Title size="small" type="semiBold">
            Permissions and defaults
          </Title>
        </FormSectionTitleWrapper>
        <CreatorPermissionsConfig
          fieldPath={fieldPath}
          label="Who can view this field during creation?"
          isReadOnly={isReadOnly}
        />
        <ViewerPermissionsConfig
          fieldPath={fieldPath}
          isReadOnly={isReadOnly}
        />
      </FormSection>
      <DisplaySettings fieldPath={fieldPath} isReadOnly={isReadOnly} />
    </WidgetSettingsContainer>
  );
}
